export default "__VITE_ASSET__CNMisyY4__"